import enUS from './en-US';
import es from './es';
var localizationMap = new Map();
localizationMap.set('en-US', enUS);
localizationMap.set('es', es);
export default localizationMap;
